import React from 'react';
import { Typography, Grid, Avatar } from '@mui/material';
import CodeIcon from '@mui/icons-material/Code';
import CreateIcon from '@mui/icons-material/Create';
import BuildIcon from '@mui/icons-material/Build';
import TextFieldsIcon from '@mui/icons-material/TextFields';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import StorageIcon from '@mui/icons-material/Storage';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import CloudIcon from '@mui/icons-material/Cloud';
import WebIcon from '@mui/icons-material/Web';
import { faProjectDiagram } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const Skills = () => {
  const skillData = [
    { title: 'Software Development', description: 'Experienced with Python, Java, C++ and C# programming languages', icon: <CodeIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Web Development', description: 'Skilled with React, Nodejs, Django, HTML, CSS, JavaScript, Bootstrap', icon: <WebIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Database Management', description: 'Created data pipelines and databases', icon: <StorageIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Mobile App Development', description: 'Familiar with Android and Flutter development', icon: <PhoneAndroidIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Data Science', description: 'Proficient in data analysis, modeling, and visualization', icon: <QueryStatsIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Machine Learning', description: 'Skilled in developing ML models for predictive analysis', icon: <BuildIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Natural Language Processing', description: 'Passionate about leveraging language for understanding and analyzing textual data', icon: <TextFieldsIcon fontSize="large" style={{color:"#2E3B55"}} /> },
    { title: 'Cloud deployment', description: 'Deployed applications and services to cloud platforms like AWS and Azure', icon: <CloudIcon fontSize="large" style={{color:"#2E3B55"}} /> },
  ];

  return (
    <div id="skills">
        <Typography variant="h4" align='center'>
        <FontAwesomeIcon icon={faProjectDiagram} /> What I can offer
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {skillData.map((skill, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Avatar sx={{ width: 64, height: 64, margin: 'auto' }}>
              {skill.icon}
            </Avatar>
            <Typography variant="h6" align="center" gutterBottom>
              {skill.title}
            </Typography>
            <Typography variant="body2" align="center">
              {skill.description}
            </Typography>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default Skills;
